<template>
  <div class="h-pager">
    <div class="h-pager-content">
      <div v-click-sound-button
           class="btn-page prev"
           :class="{ disabled: page <= 0 }"
           @click="handlePrev">
        上一页
      </div>
      <div class="current">
        {{ page + 1 }} / {{ maxPage + 1 }}
      </div>
      <div v-click-sound-button
           class="btn-page next"
           :class="{ disabled: page >= maxPage }"
           @click="handleNext">
        下一页
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'h-pager',

    props: {
      page: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 5
      },
      total: {
        type: Number,
        default: 0
      }
    },

    computed: {
      maxPage () {
        return Math.ceil(this.total / this.pageSize) - 1
      },
    },

    methods: {
      handlePrev () {
        if (this.page <= 0) {
          return
        }
        const page = Math.min(Math.max(this.page - 1, 0), this.maxPage)
        this.$emit('pageChange', page)
      },

      handleNext () {
        if (this.page >= this.maxPage) {
          return
        }
        const page = Math.max(Math.min(this.page + 1, this.maxPage), 0)
        this.$emit('pageChange', page)
      },
    },

  }
</script>

<style lang="stylus" scoped>
  .h-pager
    position relative
    display flex
    justify-content flex-end

  .h-pager-content
    padding 5px
    display flex
    line-height 16px
    font-size 12px

  .btn-page
    goldText1()
    cursor pointer
    &:active
      color darken($colorGold, 30%)
    &.disabled
      color rgba(255, 255, 255, 0.5)
      cursor not-allowed

  .current
    padding 0 10px
    whiteText1()

</style>
